import { ChartConfigVM, TableConfigVM } from "@app/shared-components/chart.interfaces"

export const DRILL_OUT_CUSTOMER_CHART_CONFIGURATIONS: ChartConfigVM[] = [

    {
        label: 'Fluid Quality',
        icon: 'description',
        title: 'Fluid',
        subtitle: 'Fluid Quality',
        appId: 'drill-out',
        tabId: 'customersheet',
        requestId: 'ed405b64-0bb8-4660-a1fe-5ba3a696e684',
        serviceUrl: '/api/SearchData/drill-out/customersheet',
        roles: ['drill-out:customer'],
        filterMap: { 'drillOutTemplateId': 'DrillOutTemplateId', 'date': 'Date' },
        isTimeCategory: true,
        metric: [
            {
                metricCol: 'DischargeViscosity',
                type: 'column',
                name: 'Discharge Viscosity'
            },
            {
                metricCol: 'ReturnViscosity',
                type: 'column',
                name: 'Return Viscosity'

            },
            {
                metricCol: 'DischargeMudWeight',
                type: 'line',
                axis: 'valueAxis',
                name: 'Discharge Mud Weight'
            },
            {
                metricCol: 'ReturnMudWeight',
                type: 'line',
                axis: 'valueAxis',
                name: 'Return Mud Weight'
            }
        ]
    },
    {
        label: 'Well Pressure vs Pump Pressure',
        icon: 'description',
        title: 'Well Pressure vs Pump Pressure',
        subtitle: 'Well Pressure vs Pump Pressure',
        appId: 'drill-out',
        tabId: 'rigreading',
        requestId: '3ff83f90-a111-4024-9e00-5b29b665ab8b',
        serviceUrl: '/api/SearchData/drill-out/rigreading',
        roles: ['drill-out:customer'],
        filterMap: { 'drillOutTemplateId': 'DrillOutTemplateId', 'date': 'Date' },
        metric: [
            {
                metricCol: 'WHP',
                type: 'line',
                name: 'Well Pressure'
            },
            {
                metricCol: 'PumpPressure',
                type: 'line',
                name: 'Pump Pressure'
            }

        ]
    },
    {
        label: 'Pickup vs. Slack Off',
        icon: 'description',
        title: 'Pickup vs. Slack Off',
        subtitle: 'Pickup vs. Slack Off',
        appId: 'drill-out',
        tabId: 'rigreading',
        requestId: '7400aa09-663b-4c59-8604-58122a48d43d',
        serviceUrl: '/api/SearchData/drill-out/rigreading',
        roles: ['drill-out:customer'],
        filterMap: { 'drillOutTemplateId': 'DrillOutTemplateId', 'date': 'Date' },
        metric: [
            {
                metricCol: 'PUWeight',
                type: 'line',
                name: 'Pickup Weight'
            },
            {
                metricCol: 'SOWeight',
                type: 'line',
                name: 'Slack Off Weight'
            }

        ]
    },
    {
        label: 'Tourque',
        icon: 'description',
        title: 'Tourque',
        subtitle: 'Tourque',
        appId: 'drill-out',
        tabId: 'rigreading',
        requestId: '4c728258-a63d-40b9-9f56-c06c70c40bff',
        serviceUrl: '/api/SearchData/drill-out/rigreading',
        roles: ['drill-out:customer'],
        filterMap: { 'drillOutTemplateId': 'DrillOutTemplateId', 'date': 'Date' },
        metric: [

            {
                metricCol: 'FreeTorque',
                type: 'line',
                name: 'Free Torque'
            },
            {
                metricCol: 'DrillTorque',
                type: 'line',
                name: 'Drill Torque'
            }

        ]
    }


]

export const CUSTOMER_TABLES_COMNFIGURATION: TableConfigVM[] = [
    {
        title: 'Rig Reading',
        icon: 'summarize',
        appId: 'drill-out',
        tabId: 'rigreading',
        requestId: 'eb342c8b-1d5f-4c20-bd3e-45042289ec34',
        filterMap: { 'drillOutTemplateId': 'DrillOutTemplateId', 'date': 'Date' },
        serviceUrl: '/api/SearchData/drill-out/rigreading',
        roles: ['drill-out:customer']
    }
]
